import React, {FC} from 'react';

import {TabbedForm} from 'components/@common/widgets/tabbed-form';
import {Changelog} from 'components/@common/widgets/tabbed-form/common-tabs/changelog';
import {IChangelogEntity} from 'components/@common/widgets/tabbed-form/common-tabs/changelog/changelog.types';
import {ETablePageQueryParams} from 'pages/table-page/query-params-aware-table/constants/table-query-params.constants';
import {useQueryParams} from 'shared/utils/query-params';
import {useGetExplanationInformationQuery} from 'store/api/explanation-information/explanation-information.api';

import {EIFormTabs, EIFormTabTitles} from './explanation-information-card.constants';
import {ExplanationInformationMainInfo} from './tabs';

export interface IExplanationInformationCardProps {
    id: string;
}

export const ExplanationInformationCard: FC<IExplanationInformationCardProps> = (
    {
        id,
    }: IExplanationInformationCardProps,
) => {
    const {removeQueryParams} = useQueryParams();

    const {
        data: explanationInfo,
        isLoading,
    } = useGetExplanationInformationQuery({id}, {skip: !id});

    const changelogData: IChangelogEntity[] | undefined = explanationInfo?.audits?.map(a => ({
        id: a.id,
        stage: a.stage,
        statusCode: a.statusCode,
        statusText: a.statusText,
        createdDate: a.createdDate,
        updatedDate: a.lastModifiedDate,
    }));

    const handleClose = () => removeQueryParams([ETablePageQueryParams.entity]);

    return (
        <TabbedForm
            title={explanationInfo ? `Карточка требования №${explanationInfo?.mainDocNumber}` : ' '}
            defaultTabKey={EIFormTabs.main}
            isLoading={isLoading}
            modalWrapped
            emptyProps={{
                isEmpty: !explanationInfo,
                description: 'Информация о требовании не найдена',
            }}
            onClose={handleClose}
            tabs={explanationInfo && (
                [
                    {
                        key: EIFormTabs.main,
                        title: EIFormTabTitles.main,
                        content: (
                            <ExplanationInformationMainInfo
                                id={id}
                                initialLoadedData={explanationInfo}
                                onClose={handleClose}
                            />
                        ),
                    },
                    {
                        key: EIFormTabs.changes,
                        title: EIFormTabTitles.changes,
                        content: changelogData && (
                            <Changelog
                                changelogData={changelogData}
                            />
                        ),
                    },
                ]
            )}
        />
    );
};
